import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/auth/auth.store";

const ProtectedRoute: React.FC = () => {
  const { isLoggedIn } = useAuthStore();
  const location = useLocation();

  if (!isLoggedIn) {
    const code = new URLSearchParams(location.search).get("code");
    if (code) {
      return <Navigate to={`/login/callback?code=${code}`} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
